import React from 'react';
import './../../../../../style/Vars.css';
import './../../../../../style/ContainersStyles.css';
import './../../../../../style/ElementsStyle.css';
import EstadisticasCatalog from './EstadisticasCatalog';

export default function EstadisticasPage() {
    return <EstadisticasCatalog />;
}
